import { render } from "./EmailVerifyPopup.vue?vue&type=template&id=200bf47d&scoped=true"
import script from "./EmailVerifyPopup.vue?vue&type=script&lang=js"
export * from "./EmailVerifyPopup.vue?vue&type=script&lang=js"

import "./emailVerifyPopup.css?vue&type=style&index=0&id=200bf47d&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-200bf47d"]])

export default __exports__